module.exports = __webpack_public_path__ + "img/gift3.5fa16dec.png";